<ng-container *transloco="let t">
  <pxw-alert type="warning" size="sm">
    <pxw-icon icon="alert" />
    <div class="restriction-alert">
      @for (row of rows(); track row.productId) {
        <div>
          <strong>{{ row.product }}</strong>
          {{
            t(row.messageKey, {
              names: row.shipping || row.payment,
              shipping: row.shipping,
              payment: row.payment,
            })
          }}
        </div>
      }
      <div class="restriction-alert__action">{{ actionText() }}</div>
    </div>
  </pxw-alert>
</ng-container>
